import React from "react";
import { Route, Switch, useLocation, useRouteMatch } from "react-router-dom";
import Login from "pages/UserAuth/Login";
import SignUp from "pages/UserAuth/SignUp";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import PageNotFound from "pages/common/ErrorPages/PageNotFound";
import * as Sentry from "@sentry/react";
import { requiresUnauth } from "./requiresAuthHOC";
import { useSelector } from "react-redux";
import { getThemeDetails, ThemeMode } from "selectors/themeSelectors";
import type { AppState } from "ee/reducers";
import { ThemeProvider } from "styled-components";
import VerificationPending from "./VerificationPending";
import VerifyUser from "./VerifyUser";
import VerificationError from "./VerificationError";
import FooterLinks from "./FooterLinks";
import { useIsMobileDevice } from "utils/hooks/useDeviceDetect";
import { getAssetUrl } from "ee/utils/airgapHelpers";
import { getTenantConfig } from "ee/selectors/tenantSelectors";
import { getAppsmithConfigs } from "ee/configs";
import LgoinHomeBgImg from "../../assets/images/lgoin_home_bg.png";

const SentryRoute = Sentry.withSentryRouting(Route);

export function UserAuth() {
  const { path } = useRouteMatch();
  const location = useLocation();
  const lightTheme = useSelector((state: AppState) =>
    getThemeDetails(state, ThemeMode.LIGHT),
  );
  const isMobileDevice = useIsMobileDevice();
  const tenantConfig = useSelector(getTenantConfig);
  const { cloudHosting } = getAppsmithConfigs();

  return (
    <ThemeProvider theme={lightTheme}>
      {/* TODO: (Albin) - chnages this to ads-v2 variable once  branding is sorted out. */}
      <div
        style={{
          background:
            "linear-gradient(180deg, #0D0D0D 0%, #310F59 60.77%, #25103F 121.55%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
        }}
        className="absolute inset-0 auth-container"
      >
        <img
          className="z-0 absolute left-0 top-0 w-full h-full object-cover"
          src={LgoinHomeBgImg}
          alt="lgoin_home_bg"
        />

        <div
          className={`absolute inset-0 auth-container flex flex-col overflow-y-auto ${
            !isMobileDevice ? "p-4" : "px-6 py-12"
          } t--auth-container justify-between z-10`}
        >
          {isMobileDevice && (
            <img
              className="h-8 mx-auto"
              src={getAssetUrl(tenantConfig.brandLogoUrl)}
            />
          )}
          <Switch location={location}>
            <SentryRoute component={Login} exact path={`${path}/login`} />
            <SentryRoute component={SignUp} exact path={`${path}/signup`} />
            <SentryRoute
              component={ResetPassword}
              exact
              path={`${path}/resetPassword`}
            />
            <SentryRoute
              component={ForgotPassword}
              exact
              path={`${path}/forgotPassword`}
            />
            <SentryRoute
              component={VerificationPending}
              exact
              path={`${path}/verificationPending`}
            />
            <SentryRoute component={VerifyUser} exact path={`${path}/verify`} />
            <SentryRoute
              component={VerificationError}
              exact
              path={`${path}/verify-error`}
            />
            <SentryRoute component={PageNotFound} />
          </Switch>
          {cloudHosting && <FooterLinks />}
        </div>
      </div>
    </ThemeProvider>
  );
}

export default requiresUnauth(UserAuth);
